import * as React from "react";
import { useNavigate } from "react-router-dom";

import { authClient } from "@/lib/auth-client";
import { isAllowedInternalEmail } from "@/lib/internal-email-domain";
import {
	buildRequiredTwoFactorSetupUrl,
	hasTwoFactorEnabled,
} from "@/lib/two-factor-policy";

export default function RootRedirectPage() {
	const navigate = useNavigate();

	React.useEffect(() => {
		let mounted = true;

		const redirect = async () => {
			try {
				const session = await authClient.getSession();
				if (!mounted) return;

				if (!session.data?.user) {
					navigate("/login", { replace: true });
					return;
				}

				const email = (session.data.user as { email?: string }).email;
				if (
					isAllowedInternalEmail(email) &&
					!hasTwoFactorEnabled(session.data.user)
				) {
					navigate(buildRequiredTwoFactorSetupUrl("/admin"), { replace: true });
					return;
				}

				navigate("/admin", { replace: true });
			} catch {
				if (!mounted) return;
				navigate("/login", { replace: true });
			}
		};

		void redirect();

		return () => {
			mounted = false;
		};
	}, [navigate]);

	return (
		<main className="flex min-h-screen items-center justify-center">
			<p className="text-muted-foreground text-sm">Redirecting…</p>
		</main>
	);
}
